var pantSizeChart =[
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 22,
    "outseam": 31.25,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 22.5,
    "outseam": 31.75,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 23,
    "outseam": 32.25,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 23.5,
    "outseam": 32.75,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 24,
    "outseam": 33.25,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 24.5,
    "outseam": 33.75,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 25,
    "outseam": 34.25,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 25.5,
    "outseam": 34.75,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 26,
    "outseam": 35.25,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 26.5,
    "outseam": 35.75,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 27,
    "outseam": 36.25,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 27.5,
    "outseam": 36.75,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 28,
    "outseam": 37.25,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 28.5,
    "outseam": 37.75,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 29,
    "outseam": 38.25,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 29.5,
    "outseam": 38.75,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 30,
    "outseam": 39.25,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 30.5,
    "outseam": 39.75,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 31,
    "outseam": 40.25,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 31.5,
    "outseam": 40.75,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 32,
    "outseam": 41.25,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 32.5,
    "outseam": 41.75,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 33,
    "outseam": 42.25,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 33.5,
    "outseam": 42.75,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 34,
    "outseam": 43.25,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 34.5,
    "outseam": 43.75,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 35,
    "outseam": 44.25,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 35.5,
    "outseam": 44.75,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 36,
    "outseam": 45.25,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 36.5,
    "outseam": 45.75,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 37,
    "outseam": 46.25,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 37.5,
    "outseam": 46.75,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 26,
    "half_waist_width": 14.3,
    "hip_width": 16.75,
    "front_rise": 10,
    "back_rise": 13.75,
    "inseam": 38,
    "outseam": 47.25,
    "thigh_width": 10.25,
    "knee_width": 7.75,
    "bottom_leg_opening": 6
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 22,
    "outseam": 31.5,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 22.5,
    "outseam": 32,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 23,
    "outseam": 32.5,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 23.5,
    "outseam": 33,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 24,
    "outseam": 33.5,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 24.5,
    "outseam": 34,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 25,
    "outseam": 34.5,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 25.5,
    "outseam": 35,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 26,
    "outseam": 35.5,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 26.5,
    "outseam": 36,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 27,
    "outseam": 36.5,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 27.5,
    "outseam": 37,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 28,
    "outseam": 37.5,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 28.5,
    "outseam": 38,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 29,
    "outseam": 38.5,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 29.5,
    "outseam": 39,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 30,
    "outseam": 39.5,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 30.5,
    "outseam": 40,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 31,
    "outseam": 40.5,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 31.5,
    "outseam": 41,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 32,
    "outseam": 41.5,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 32.5,
    "outseam": 42,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 33,
    "outseam": 42.5,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 33.5,
    "outseam": 43,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 34,
    "outseam": 43.5,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 34.5,
    "outseam": 44,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 35,
    "outseam": 44.5,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 35.5,
    "outseam": 45,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 36,
    "outseam": 45.5,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 36.5,
    "outseam": 46,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 37,
    "outseam": 46.5,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 37.5,
    "outseam": 47,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 27,
    "half_waist_width": 14.8,
    "hip_width": 17.25,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 38,
    "outseam": 47.5,
    "thigh_width": 10.5,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 22,
    "outseam": 31.5,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 22.5,
    "outseam": 32,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 23,
    "outseam": 32.5,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 23.5,
    "outseam": 33,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 24,
    "outseam": 33.5,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 24.5,
    "outseam": 34,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 25,
    "outseam": 34.5,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 25.5,
    "outseam": 35,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 26,
    "outseam": 35.5,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 26.5,
    "outseam": 36,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 27,
    "outseam": 36.5,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 27.5,
    "outseam": 37,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 28,
    "outseam": 37.5,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 28.5,
    "outseam": 38,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 29,
    "outseam": 38.5,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 29.5,
    "outseam": 39,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 30,
    "outseam": 39.5,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 30.5,
    "outseam": 40,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 31,
    "outseam": 40.5,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 31.5,
    "outseam": 41,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 32,
    "outseam": 41.5,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 32.5,
    "outseam": 42,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 33,
    "outseam": 42.5,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 33.5,
    "outseam": 43,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 34,
    "outseam": 43.5,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 34.5,
    "outseam": 44,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 35,
    "outseam": 44.5,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 35.5,
    "outseam": 45,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 36,
    "outseam": 45.5,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 36.5,
    "outseam": 46,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 37,
    "outseam": 46.5,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 37.5,
    "outseam": 47,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 28,
    "half_waist_width": 15.3,
    "hip_width": 17.75,
    "front_rise": 10.25,
    "back_rise": 14,
    "inseam": 38,
    "outseam": 47.5,
    "thigh_width": 10.75,
    "knee_width": 8,
    "bottom_leg_opening": 6.25
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 22,
    "outseam": 31.75,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 22.5,
    "outseam": 32.25,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 23,
    "outseam": 32.75,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 23.5,
    "outseam": 33.25,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 24,
    "outseam": 33.75,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 24.5,
    "outseam": 34.25,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 25,
    "outseam": 34.75,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 25.5,
    "outseam": 35.25,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 26,
    "outseam": 35.75,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 26.5,
    "outseam": 36.25,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 27,
    "outseam": 36.75,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 27.5,
    "outseam": 37.25,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 28,
    "outseam": 37.75,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 28.5,
    "outseam": 38.25,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 29,
    "outseam": 38.75,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 29.5,
    "outseam": 39.25,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 30,
    "outseam": 39.75,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 30.5,
    "outseam": 40.25,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 31,
    "outseam": 40.75,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 31.5,
    "outseam": 41.25,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 32,
    "outseam": 41.75,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 32.5,
    "outseam": 42.25,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 33,
    "outseam": 42.75,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 33.5,
    "outseam": 43.25,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 34,
    "outseam": 43.75,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 34.5,
    "outseam": 44.25,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 35,
    "outseam": 44.75,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 35.5,
    "outseam": 45.25,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 36,
    "outseam": 45.75,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 36.5,
    "outseam": 46.25,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 37,
    "outseam": 46.75,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 37.5,
    "outseam": 47.25,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 29,
    "half_waist_width": 15.8,
    "hip_width": 18.25,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 38,
    "outseam": 47.75,
    "thigh_width": 11,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 22,
    "outseam": 31.75,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 22.5,
    "outseam": 32.25,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 23,
    "outseam": 32.75,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 23.5,
    "outseam": 33.25,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 24,
    "outseam": 33.75,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 24.5,
    "outseam": 34.25,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 25,
    "outseam": 34.75,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 25.5,
    "outseam": 35.25,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 26,
    "outseam": 35.75,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 26.5,
    "outseam": 36.25,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 27,
    "outseam": 36.75,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 27.5,
    "outseam": 37.25,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 28,
    "outseam": 37.75,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 28.5,
    "outseam": 38.25,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 29,
    "outseam": 38.75,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 29.5,
    "outseam": 39.25,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 30,
    "outseam": 39.75,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 30.5,
    "outseam": 40.25,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 31,
    "outseam": 40.75,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 31.5,
    "outseam": 41.25,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 32,
    "outseam": 41.75,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 32.5,
    "outseam": 42.25,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 33,
    "outseam": 42.75,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 33.5,
    "outseam": 43.25,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 34,
    "outseam": 43.75,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 34.5,
    "outseam": 44.25,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 35,
    "outseam": 44.75,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 35.5,
    "outseam": 45.25,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 36,
    "outseam": 45.75,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 36.5,
    "outseam": 46.25,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 37,
    "outseam": 46.75,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 37.5,
    "outseam": 47.25,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 30,
    "half_waist_width": 16.3,
    "hip_width": 18.75,
    "front_rise": 10.5,
    "back_rise": 14.25,
    "inseam": 38,
    "outseam": 47.75,
    "thigh_width": 11.25,
    "knee_width": 8.25,
    "bottom_leg_opening": 6.5
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 22,
    "outseam": 32,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 22.5,
    "outseam": 32.5,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 23,
    "outseam": 33,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 23.5,
    "outseam": 33.5,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 24,
    "outseam": 34,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 24.5,
    "outseam": 34.5,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 25,
    "outseam": 35,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 25.5,
    "outseam": 35.5,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 26,
    "outseam": 36,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 26.5,
    "outseam": 36.5,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 27,
    "outseam": 37,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 27.5,
    "outseam": 37.5,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 28,
    "outseam": 38,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 28.5,
    "outseam": 38.5,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 29,
    "outseam": 39,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 29.5,
    "outseam": 39.5,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 30,
    "outseam": 40,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 30.5,
    "outseam": 40.5,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 31,
    "outseam": 41,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 31.5,
    "outseam": 41.5,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 32,
    "outseam": 42,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 32.5,
    "outseam": 42.5,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 33,
    "outseam": 43,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 33.5,
    "outseam": 43.5,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 34,
    "outseam": 44,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 34.5,
    "outseam": 44.5,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 35,
    "outseam": 45,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 35.5,
    "outseam": 45.5,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 36,
    "outseam": 46,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 36.5,
    "outseam": 46.5,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 37,
    "outseam": 47,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 37.5,
    "outseam": 47.5,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 31,
    "half_waist_width": 16.8,
    "hip_width": 19.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 38,
    "outseam": 48,
    "thigh_width": 11.5,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 22,
    "outseam": 32,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 22.5,
    "outseam": 32.5,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 23,
    "outseam": 33,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 23.5,
    "outseam": 33.5,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 24,
    "outseam": 34,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 24.5,
    "outseam": 34.5,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 25,
    "outseam": 35,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 25.5,
    "outseam": 35.5,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 26,
    "outseam": 36,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 26.5,
    "outseam": 36.5,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 27,
    "outseam": 37,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 27.5,
    "outseam": 37.5,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 28,
    "outseam": 38,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 28.5,
    "outseam": 38.5,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 29,
    "outseam": 39,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 29.5,
    "outseam": 39.5,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 30,
    "outseam": 40,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 30.5,
    "outseam": 40.5,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 31,
    "outseam": 41,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 31.5,
    "outseam": 41.5,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 32,
    "outseam": 42,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 32.5,
    "outseam": 42.5,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 33,
    "outseam": 43,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 33.5,
    "outseam": 43.5,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 34,
    "outseam": 44,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 34.5,
    "outseam": 44.5,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 35,
    "outseam": 45,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 35.5,
    "outseam": 45.5,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 36,
    "outseam": 46,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 36.5,
    "outseam": 46.5,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 37,
    "outseam": 47,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 37.5,
    "outseam": 47.5,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 32,
    "half_waist_width": 17.3,
    "hip_width": 19.75,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 38,
    "outseam": 48,
    "thigh_width": 11.75,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 22,
    "outseam": 32,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 22.5,
    "outseam": 32.5,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 23,
    "outseam": 33,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 23.5,
    "outseam": 33.5,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 24,
    "outseam": 34,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 24.5,
    "outseam": 34.5,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 25,
    "outseam": 35,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 25.5,
    "outseam": 35.5,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 26,
    "outseam": 36,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 26.5,
    "outseam": 36.5,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 27,
    "outseam": 37,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 27.5,
    "outseam": 37.5,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 28,
    "outseam": 38,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 28.5,
    "outseam": 38.5,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 29,
    "outseam": 39,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 29.5,
    "outseam": 39.5,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 30,
    "outseam": 40,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 30.5,
    "outseam": 40.5,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 31,
    "outseam": 41,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 31.5,
    "outseam": 41.5,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 32,
    "outseam": 42,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 32.5,
    "outseam": 42.5,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 33,
    "outseam": 43,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 33.5,
    "outseam": 43.5,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 34,
    "outseam": 44,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 34.5,
    "outseam": 44.5,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 35,
    "outseam": 45,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 35.5,
    "outseam": 45.5,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 36,
    "outseam": 46,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 36.5,
    "outseam": 46.5,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 37,
    "outseam": 47,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 37.5,
    "outseam": 47.5,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 33,
    "half_waist_width": 17.8,
    "hip_width": 20.25,
    "front_rise": 10.75,
    "back_rise": 14.5,
    "inseam": 38,
    "outseam": 48,
    "thigh_width": 12,
    "knee_width": 8.5,
    "bottom_leg_opening": 6.75
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 22,
    "outseam": 32.5,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 22.5,
    "outseam": 33,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 23,
    "outseam": 33.5,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 23.5,
    "outseam": 34,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 24,
    "outseam": 34.5,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 24.5,
    "outseam": 35,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 25,
    "outseam": 35.5,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 25.5,
    "outseam": 36,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 26,
    "outseam": 36.5,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 26.5,
    "outseam": 37,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 27,
    "outseam": 37.5,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 27.5,
    "outseam": 38,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 28,
    "outseam": 38.5,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 28.5,
    "outseam": 39,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 29,
    "outseam": 39.5,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 29.5,
    "outseam": 40,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 30,
    "outseam": 40.5,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 30.5,
    "outseam": 41,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 31,
    "outseam": 41.5,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 31.5,
    "outseam": 42,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 32,
    "outseam": 42.5,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 32.5,
    "outseam": 43,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 33,
    "outseam": 43.5,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 33.5,
    "outseam": 44,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 34,
    "outseam": 44.5,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 34.5,
    "outseam": 45,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 35,
    "outseam": 45.5,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 35.5,
    "outseam": 46,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 36,
    "outseam": 46.5,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 36.5,
    "outseam": 47,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 37,
    "outseam": 47.5,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 37.5,
    "outseam": 48,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 34,
    "half_waist_width": 18.3,
    "hip_width": 20.75,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 38,
    "outseam": 48.5,
    "thigh_width": 12.25,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 22,
    "outseam": 32.5,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 22.5,
    "outseam": 33,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 23,
    "outseam": 33.5,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 23.5,
    "outseam": 34,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 24,
    "outseam": 34.5,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 24.5,
    "outseam": 35,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 25,
    "outseam": 35.5,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 25.5,
    "outseam": 36,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 26,
    "outseam": 36.5,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 26.5,
    "outseam": 37,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 27,
    "outseam": 37.5,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 27.5,
    "outseam": 38,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 28,
    "outseam": 38.5,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 28.5,
    "outseam": 39,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 29,
    "outseam": 39.5,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 29.5,
    "outseam": 40,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 30,
    "outseam": 40.5,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 30.5,
    "outseam": 41,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 31,
    "outseam": 41.5,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 31.5,
    "outseam": 42,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 32,
    "outseam": 42.5,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 32.5,
    "outseam": 43,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 33,
    "outseam": 43.5,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 33.5,
    "outseam": 44,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 34,
    "outseam": 44.5,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 34.5,
    "outseam": 45,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 35,
    "outseam": 45.5,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 35.5,
    "outseam": 46,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 36,
    "outseam": 46.5,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 36.5,
    "outseam": 47,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 37,
    "outseam": 47.5,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 37.5,
    "outseam": 48,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 35,
    "half_waist_width": 18.8,
    "hip_width": 21.25,
    "front_rise": 11.25,
    "back_rise": 15,
    "inseam": 38,
    "outseam": 48.5,
    "thigh_width": 12.5,
    "knee_width": 8.75,
    "bottom_leg_opening": 7
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 22,
    "outseam": 32.75,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 22.5,
    "outseam": 33.25,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 23,
    "outseam": 33.75,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 23.5,
    "outseam": 34.25,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 24,
    "outseam": 34.75,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 24.5,
    "outseam": 35.25,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 25,
    "outseam": 35.75,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 25.5,
    "outseam": 36.25,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 26,
    "outseam": 36.75,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 26.5,
    "outseam": 37.25,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 27,
    "outseam": 37.75,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 27.5,
    "outseam": 38.25,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 28,
    "outseam": 38.75,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 28.5,
    "outseam": 39.25,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 29,
    "outseam": 39.75,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 29.5,
    "outseam": 40.25,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 30,
    "outseam": 40.75,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 30.5,
    "outseam": 41.25,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 31,
    "outseam": 41.75,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 31.5,
    "outseam": 42.25,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 32,
    "outseam": 42.75,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 32.5,
    "outseam": 43.25,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 33,
    "outseam": 43.75,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 33.5,
    "outseam": 44.25,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 34,
    "outseam": 44.75,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 34.5,
    "outseam": 45.25,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 35,
    "outseam": 45.75,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 35.5,
    "outseam": 46.25,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 36,
    "outseam": 46.75,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 36.5,
    "outseam": 47.25,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 37,
    "outseam": 47.75,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 37.5,
    "outseam": 48.25,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 36,
    "half_waist_width": 19.3,
    "hip_width": 21.75,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 38,
    "outseam": 48.75,
    "thigh_width": 12.75,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 22,
    "outseam": 32.75,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 22.5,
    "outseam": 33.25,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 23,
    "outseam": 33.75,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 23.5,
    "outseam": 34.25,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 24,
    "outseam": 34.75,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 24.5,
    "outseam": 35.25,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 25,
    "outseam": 35.75,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 25.5,
    "outseam": 36.25,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 26,
    "outseam": 36.75,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 26.5,
    "outseam": 37.25,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 27,
    "outseam": 37.75,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 27.5,
    "outseam": 38.25,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 28,
    "outseam": 38.75,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 28.5,
    "outseam": 39.25,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 29,
    "outseam": 39.75,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 29.5,
    "outseam": 40.25,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 30,
    "outseam": 40.75,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 30.5,
    "outseam": 41.25,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 31,
    "outseam": 41.75,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 31.5,
    "outseam": 42.25,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 32,
    "outseam": 42.75,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 32.5,
    "outseam": 43.25,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 33,
    "outseam": 43.75,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 33.5,
    "outseam": 44.25,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 34,
    "outseam": 44.75,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 34.5,
    "outseam": 45.25,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 35,
    "outseam": 45.75,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 35.5,
    "outseam": 46.25,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 36,
    "outseam": 46.75,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 36.5,
    "outseam": 47.25,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 37,
    "outseam": 47.75,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 37.5,
    "outseam": 48.25,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 37,
    "half_waist_width": 19.8,
    "hip_width": 22.25,
    "front_rise": 11.5,
    "back_rise": 15.25,
    "inseam": 38,
    "outseam": 48.75,
    "thigh_width": 13,
    "knee_width": 9,
    "bottom_leg_opening": 7.25
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 22,
    "outseam": 33,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 22.5,
    "outseam": 33.5,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 23,
    "outseam": 34,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 23.5,
    "outseam": 34.5,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 24,
    "outseam": 35,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 24.5,
    "outseam": 35.5,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 25,
    "outseam": 36,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 25.5,
    "outseam": 36.5,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 26,
    "outseam": 37,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 26.5,
    "outseam": 37.5,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 27,
    "outseam": 38,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 27.5,
    "outseam": 38.5,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 28,
    "outseam": 39,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 28.5,
    "outseam": 39.5,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 29,
    "outseam": 40,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 29.5,
    "outseam": 40.5,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 30,
    "outseam": 41,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 30.5,
    "outseam": 41.5,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 31,
    "outseam": 42,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 31.5,
    "outseam": 42.5,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 32,
    "outseam": 43,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 32.5,
    "outseam": 43.5,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 33,
    "outseam": 44,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 33.5,
    "outseam": 44.5,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 34,
    "outseam": 45,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 34.5,
    "outseam": 45.5,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 35,
    "outseam": 46,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 35.5,
    "outseam": 46.5,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 36,
    "outseam": 47,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 36.5,
    "outseam": 47.5,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 37,
    "outseam": 48,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 37.5,
    "outseam": 48.5,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 38,
    "half_waist_width": 20.3,
    "hip_width": 22.75,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 38,
    "outseam": 49,
    "thigh_width": 13.25,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 22,
    "outseam": 33,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 22.5,
    "outseam": 33.5,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 23,
    "outseam": 34,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 23.5,
    "outseam": 34.5,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 24,
    "outseam": 35,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 24.5,
    "outseam": 35.5,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 25,
    "outseam": 36,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 25.5,
    "outseam": 36.5,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 26,
    "outseam": 37,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 26.5,
    "outseam": 37.5,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 27,
    "outseam": 38,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 27.5,
    "outseam": 38.5,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 28,
    "outseam": 39,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 28.5,
    "outseam": 39.5,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 29,
    "outseam": 40,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 29.5,
    "outseam": 40.5,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 30,
    "outseam": 41,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 30.5,
    "outseam": 41.5,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 31,
    "outseam": 42,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 31.5,
    "outseam": 42.5,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 32,
    "outseam": 43,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 32.5,
    "outseam": 43.5,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 33,
    "outseam": 44,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 33.5,
    "outseam": 44.5,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 34,
    "outseam": 45,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 34.5,
    "outseam": 45.5,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 35,
    "outseam": 46,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 35.5,
    "outseam": 46.5,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 36,
    "outseam": 47,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 36.5,
    "outseam": 47.5,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 37,
    "outseam": 48,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 37.5,
    "outseam": 48.5,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 39,
    "half_waist_width": 20.8,
    "hip_width": 23.25,
    "front_rise": 11.75,
    "back_rise": 15.5,
    "inseam": 38,
    "outseam": 49,
    "thigh_width": 13.5,
    "knee_width": 9.25,
    "bottom_leg_opening": 7.5
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 22,
    "outseam": 33.25,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 22.5,
    "outseam": 33.75,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 23,
    "outseam": 34.25,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 23.5,
    "outseam": 34.75,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 24,
    "outseam": 35.25,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 24.5,
    "outseam": 35.75,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 25,
    "outseam": 36.25,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 25.5,
    "outseam": 36.75,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 26,
    "outseam": 37.25,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 26.5,
    "outseam": 37.75,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 27,
    "outseam": 38.25,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 27.5,
    "outseam": 38.75,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 28,
    "outseam": 39.25,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 28.5,
    "outseam": 39.75,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 29,
    "outseam": 40.25,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 29.5,
    "outseam": 40.75,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 30,
    "outseam": 41.25,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 30.5,
    "outseam": 41.75,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 31,
    "outseam": 42.25,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 31.5,
    "outseam": 42.75,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 32,
    "outseam": 43.25,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 32.5,
    "outseam": 43.75,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 33,
    "outseam": 44.25,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 33.5,
    "outseam": 44.75,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 34,
    "outseam": 45.25,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 34.5,
    "outseam": 45.75,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 35,
    "outseam": 46.25,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 35.5,
    "outseam": 46.75,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 36,
    "outseam": 47.25,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 36.5,
    "outseam": 47.75,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 37,
    "outseam": 48.25,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 37.5,
    "outseam": 48.75,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 40,
    "half_waist_width": 21.3,
    "hip_width": 23.75,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 38,
    "outseam": 49.25,
    "thigh_width": 13.75,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 22,
    "outseam": 33.25,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 22.5,
    "outseam": 33.75,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 23,
    "outseam": 34.25,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 23.5,
    "outseam": 34.75,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 24,
    "outseam": 35.25,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 24.5,
    "outseam": 35.75,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 25,
    "outseam": 36.25,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 25.5,
    "outseam": 36.75,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 26,
    "outseam": 37.25,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 26.5,
    "outseam": 37.75,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 27,
    "outseam": 38.25,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 27.5,
    "outseam": 38.75,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 28,
    "outseam": 39.25,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 28.5,
    "outseam": 39.75,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 29,
    "outseam": 40.25,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 29.5,
    "outseam": 40.75,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 30,
    "outseam": 41.25,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 30.5,
    "outseam": 41.75,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 31,
    "outseam": 42.25,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 31.5,
    "outseam": 42.75,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 32,
    "outseam": 43.25,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 32.5,
    "outseam": 43.75,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 33,
    "outseam": 44.25,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 33.5,
    "outseam": 44.75,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 34,
    "outseam": 45.25,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 34.5,
    "outseam": 45.75,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 35,
    "outseam": 46.25,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 35.5,
    "outseam": 46.75,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 36,
    "outseam": 47.25,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 36.5,
    "outseam": 47.75,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 37,
    "outseam": 48.25,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 37.5,
    "outseam": 48.75,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 41,
    "half_waist_width": 21.8,
    "hip_width": 24.25,
    "front_rise": 12,
    "back_rise": 15.75,
    "inseam": 38,
    "outseam": 49.25,
    "thigh_width": 14,
    "knee_width": 9.5,
    "bottom_leg_opening": 7.75
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 22,
    "outseam": 33.5,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 22.5,
    "outseam": 34,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 23,
    "outseam": 34.5,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 23.5,
    "outseam": 35,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 24,
    "outseam": 35.5,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 24.5,
    "outseam": 36,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 25,
    "outseam": 36.5,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 25.5,
    "outseam": 37,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 26,
    "outseam": 37.5,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 26.5,
    "outseam": 38,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 27,
    "outseam": 38.5,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 27.5,
    "outseam": 39,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 28,
    "outseam": 39.5,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 28.5,
    "outseam": 40,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 29,
    "outseam": 40.5,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 29.5,
    "outseam": 41,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 30,
    "outseam": 41.5,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 30.5,
    "outseam": 42,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 31,
    "outseam": 42.5,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 31.5,
    "outseam": 43,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 32,
    "outseam": 43.5,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 32.5,
    "outseam": 44,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 33,
    "outseam": 44.5,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 33.5,
    "outseam": 45,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 34,
    "outseam": 45.5,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 34.5,
    "outseam": 46,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 35,
    "outseam": 46.5,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 35.5,
    "outseam": 47,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 36,
    "outseam": 47.5,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 36.5,
    "outseam": 48,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 37,
    "outseam": 48.5,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 37.5,
    "outseam": 49,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 42,
    "half_waist_width": 22.3,
    "hip_width": 24.75,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 38,
    "outseam": 49.5,
    "thigh_width": 14.25,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 22,
    "outseam": 33.5,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 22.5,
    "outseam": 34,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 23,
    "outseam": 34.5,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 23.5,
    "outseam": 35,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 24,
    "outseam": 35.5,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 24.5,
    "outseam": 36,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 25,
    "outseam": 36.5,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 25.5,
    "outseam": 37,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 26,
    "outseam": 37.5,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 26.5,
    "outseam": 38,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 27,
    "outseam": 38.5,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 27.5,
    "outseam": 39,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 28,
    "outseam": 39.5,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 28.5,
    "outseam": 40,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 29,
    "outseam": 40.5,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 29.5,
    "outseam": 41,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 30,
    "outseam": 41.5,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 30.5,
    "outseam": 42,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 31,
    "outseam": 42.5,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 31.5,
    "outseam": 43,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 32,
    "outseam": 43.5,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 32.5,
    "outseam": 44,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 33,
    "outseam": 44.5,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 33.5,
    "outseam": 45,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 34,
    "outseam": 45.5,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 34.5,
    "outseam": 46,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 35,
    "outseam": 46.5,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 35.5,
    "outseam": 47,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 36,
    "outseam": 47.5,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 36.5,
    "outseam": 48,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 37,
    "outseam": 48.5,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 37.5,
    "outseam": 49,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 43,
    "half_waist_width": 22.8,
    "hip_width": 25.25,
    "front_rise": 12.25,
    "back_rise": 16,
    "inseam": 38,
    "outseam": 49.5,
    "thigh_width": 14.5,
    "knee_width": 9.75,
    "bottom_leg_opening": 8
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 22,
    "outseam": 33.75,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 22.5,
    "outseam": 34.25,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 23,
    "outseam": 34.75,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 23.5,
    "outseam": 35.25,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 24,
    "outseam": 35.75,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 24.5,
    "outseam": 36.25,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 25,
    "outseam": 36.75,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 25.5,
    "outseam": 37.25,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 26,
    "outseam": 37.75,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 26.5,
    "outseam": 38.25,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 27,
    "outseam": 38.75,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 27.5,
    "outseam": 39.25,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 28,
    "outseam": 39.75,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 28.5,
    "outseam": 40.25,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 29,
    "outseam": 40.75,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 29.5,
    "outseam": 41.25,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 30,
    "outseam": 41.75,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 30.5,
    "outseam": 42.25,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 31,
    "outseam": 42.75,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 31.5,
    "outseam": 43.25,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 32,
    "outseam": 43.75,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 32.5,
    "outseam": 44.25,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 33,
    "outseam": 44.75,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 33.5,
    "outseam": 45.25,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 34,
    "outseam": 45.75,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 34.5,
    "outseam": 46.25,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 35,
    "outseam": 46.75,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 35.5,
    "outseam": 47.25,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 36,
    "outseam": 47.75,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 36.5,
    "outseam": 48.25,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 37,
    "outseam": 48.75,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 37.5,
    "outseam": 49.25,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 44,
    "half_waist_width": 23.3,
    "hip_width": 25.75,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 38,
    "outseam": 49.75,
    "thigh_width": 14.75,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 22,
    "outseam": 33.75,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 22.5,
    "outseam": 34.25,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 23,
    "outseam": 34.75,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 23.5,
    "outseam": 35.25,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 24,
    "outseam": 35.75,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 24.5,
    "outseam": 36.25,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 25,
    "outseam": 36.75,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 25.5,
    "outseam": 37.25,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 26,
    "outseam": 37.75,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 26.5,
    "outseam": 38.25,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 27,
    "outseam": 38.75,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 27.5,
    "outseam": 39.25,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 28,
    "outseam": 39.75,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 28.5,
    "outseam": 40.25,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 29,
    "outseam": 40.75,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 29.5,
    "outseam": 41.25,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 30,
    "outseam": 41.75,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 30.5,
    "outseam": 42.25,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 31,
    "outseam": 42.75,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 31.5,
    "outseam": 43.25,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 32,
    "outseam": 43.75,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 32.5,
    "outseam": 44.25,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 33,
    "outseam": 44.75,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 33.5,
    "outseam": 45.25,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 34,
    "outseam": 45.75,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 34.5,
    "outseam": 46.25,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 35,
    "outseam": 46.75,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 35.5,
    "outseam": 47.25,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 36,
    "outseam": 47.75,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 36.5,
    "outseam": 48.25,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 37,
    "outseam": 48.75,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 37.5,
    "outseam": 49.25,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 45,
    "half_waist_width": 23.8,
    "hip_width": 26.25,
    "front_rise": 12.5,
    "back_rise": 16.25,
    "inseam": 38,
    "outseam": 49.75,
    "thigh_width": 15,
    "knee_width": 10,
    "bottom_leg_opening": 8.25
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 22,
    "outseam": 34,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 22.5,
    "outseam": 34.5,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 23,
    "outseam": 35,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 23.5,
    "outseam": 35.5,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 24,
    "outseam": 36,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 24.5,
    "outseam": 36.5,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 25,
    "outseam": 37,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 25.5,
    "outseam": 37.5,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 26,
    "outseam": 38,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 26.5,
    "outseam": 38.5,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 27,
    "outseam": 39,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 27.5,
    "outseam": 39.5,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 28,
    "outseam": 40,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 28.5,
    "outseam": 40.5,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 29,
    "outseam": 41,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 29.5,
    "outseam": 41.5,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 30,
    "outseam": 42,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 30.5,
    "outseam": 42.5,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 31,
    "outseam": 43,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 31.5,
    "outseam": 43.5,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 32,
    "outseam": 44,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 32.5,
    "outseam": 44.5,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 33,
    "outseam": 45,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 33.5,
    "outseam": 45.5,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 34,
    "outseam": 46,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 34.5,
    "outseam": 46.5,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 35,
    "outseam": 47,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 35.5,
    "outseam": 47.5,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 36,
    "outseam": 48,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 36.5,
    "outseam": 48.5,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 37,
    "outseam": 49,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 37.5,
    "outseam": 49.5,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  },
  {
    "pant_size": 46,
    "half_waist_width": 24.3,
    "hip_width": 26.75,
    "front_rise": 12.75,
    "back_rise": 16.5,
    "inseam": 38,
    "outseam": 50,
    "thigh_width": 15.25,
    "knee_width": 10.25,
    "bottom_leg_opening": 8.5
  }
]